import Services from "../components/Colab_Services/Services"

export default {
    name: "Services",
    component: Services,
    url: "/services",
    exact: true,
    requireAuth: true
}